import { Link } from "react-router-dom";
import "./UnsubscribeTemplate.css";

const UnsubscribeTemplate = ({
  email,
  reason,
  errors,
  loading,
  status,
  apiError,
  onEmailChange,
  onReasonChange,
  onSubmit,
}) => (
  <main className="unsub-page">
    <section className="unsub-card" aria-live="polite">
      {status === "success" ? (
        <div className="unsub-success">
          <div className="unsub-success__icon" aria-hidden="true">✓</div>
          <h1 className="unsub-title">Vous êtes désabonné</h1>
          <p className="unsub-subtitle">
            Vous ne recevrez plus d'alertes à l'adresse <strong>{email}</strong>. Merci pour votre
            retour, il nous aide à améliorer le service.
          </p>
          <Link to="/" className="unsub-btn unsub-btn--ghost">
            Page d'accueil
          </Link>
        </div>
      ) : (
        <form onSubmit={onSubmit} noValidate>
          <h1 className="unsub-title">Se désabonner des alertes</h1>
          <p className="unsub-subtitle">
            Confirmez votre adresse e-mail et dites-nous pourquoi vous partez.
          </p>

          <div className="unsub-field">
            <label htmlFor="unsub-email" className="unsub-label">Adresse e-mail</label>
            <input
              id="unsub-email"
              type="email"
              autoComplete="email"
              placeholder="Adresse e-mail"
              value={email}
              onChange={(e) => onEmailChange(e.target.value)}
              aria-invalid={!!errors.email}
              className={errors.email ? "has-error" : ""}
            />
            {errors.email && <span className="unsub-error">{errors.email}</span>}
          </div>

          <div className="unsub-field">
            <label htmlFor="unsub-reason" className="unsub-label">Raison du désabonnement (facultatif)</label>
            <textarea
              id="unsub-reason"
              rows={4}
              placeholder="Indiquez la raison de votre départ (facultatif)"
              value={reason}
              onChange={(e) => onReasonChange(e.target.value)}
              aria-invalid={!!errors.reason}
              className={errors.reason ? "has-error" : ""}
            />
            {errors.reason && <span className="unsub-error">{errors.reason}</span>}
          </div>

          {status === "error" && (
            <p className="unsub-alert" role="alert">
              {apiError}
            </p>
          )}

          <button type="submit" className="unsub-btn" disabled={loading}>
            {loading ? "Traitement…" : "VALIDER LE DÉSABONNEMENT"}
          </button>
        </form>
      )}
    </section>
  </main>
);

export default UnsubscribeTemplate;